export const visitorInfoBlockDefaultStates = {
  general: true,
  contactAddress: true,
  preChatForm: true,
  routing: true,
  info: true,
  events: true,
  agents: false,
  postChatForm: false,
  visitHistory: false,
  outreachDetails: false,
  outreach: false,
  customFields: false
};
